import { Nav } from "react-bootstrap";

import { NotFound } from "@/app/pages/NotFound";
import { BootstrapNavLink } from "@/components/BootstrapNavLink";
import { Icon } from "@/components/Icon";
import { useParams } from "react-router";

export const EstimateTrackerNav: React.FC = () => {
  // Get the estimate number from the URL route parameters
  const params = useParams();
  if (!params["estimateNumber"]) return <NotFound />;
  const estimateNumber = params["estimateNumber"];

  return (
    <Nav
      activeKey={window.location.href}
      className="flex-column nav-pills"
      style={{ "--bs-nav-pills-border-radius": 0 }}
    >
      <Nav.Item className="text-wrap px-3">
        <h2>{estimateNumber}</h2>
      </Nav.Item>
      <Nav.Item>
        <BootstrapNavLink to={`/estimate/${estimateNumber}/details`}>
          <Icon icon="file-text" className="me-2" />
          Estimate Details
        </BootstrapNavLink>
      </Nav.Item>
      <Nav.Item>
        <BootstrapNavLink to={`/estimate/${estimateNumber}/bom-hierarchy`}>
          <Icon icon="list-nested" className="me-2" />
          BOM Hierarchy
        </BootstrapNavLink>
      </Nav.Item>
      <Nav.Item>
        <BootstrapNavLink to={`/estimate/${estimateNumber}/bom-by-component`}>
          <Icon icon="list" className="me-2" />
          BOM By Component
        </BootstrapNavLink>
      </Nav.Item>
    </Nav>
  );
};
